import { css } from '@emotion/react';
import lineHeights from '@theme/foundations/lineHeights';
import { ThemeColors } from '../theme/foundations/colors';
import { colorIsDark } from './colors';
// Resolve a dot-delimited theme color token (e.g. 'primary.500') off
// ThemeColors. Local replacement for lodash/get so this util — which the
// payment popup pulls in — does not drag lodash into the bundle (BENG-4169).
const getColor = (path) => path
    .split('.')
    .reduce((value, key) => value && typeof value === 'object'
    ? value[key]
    : undefined, ThemeColors);
export const backgroundStyles = (props) => {
    const color = getColor(props.background);
    if (!color) {
        return css ``;
    }
    return css `
    background-color: ${color};
  `;
};
export const colorStyle = (color, contrastColor) => {
    if (contrastColor) {
        const backgroundColor = getColor(contrastColor);
        const isDark = colorIsDark(backgroundColor);
        if (isDark) {
            return css `
        color: ${ThemeColors.white[500]};
      `;
        }
        else {
            return css `
        color: ${ThemeColors.black[500]};
      `;
        }
    }
    const colorValue = getColor(color);
    return css `
    color: ${colorValue};
  `;
};
/**
 * Calculates the max-height for a Text component based on its computed font size,
 * line-height, and the desired number of lines.
 */
export const calculateLineClamp = ({ lineHeight = lineHeights['base'], noOfLines, }) => {
    // 1em makes the calculation relative to the element's current font size
    return {
        maxHeight: `calc(1em * ${lineHeight} * ${noOfLines})`,
        noOfLines,
    };
};
